import type { ReactElement } from "react"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import type { Components } from "react-markdown"
import BaseMarkdown from "../Base"

interface Props {
  children: string
  components?: Components
}

function Caption({ children, components }: Props): ReactElement<Props> {
  const baseMarkdownOverrides = getBaseMarkdownOverrides({
    typography: { small: "tiny2", medium: "xsmall2_u", large: "xsmall2_u" },
    boldTypography: "xsmall3",
    pushSpace: 1.5,
  })

  return (
    <div className="uppercase">
      <BaseMarkdown components={components || baseMarkdownOverrides}>
        {children}
      </BaseMarkdown>
    </div>
  )
}

export default Caption
